export const platTypes = [
  { label: "android", value: 1 },
  { label: "google", value: 2 },
  { label: "ios", value: 3 },
];
